import { createFileRoute } from '@tanstack/react-router';

/**
 * Health Check Route
 *
 * Accessible at /healthz (no locale prefix)
 * Used for load balancer health checks and monitoring
 */
export const Route = createFileRoute('/healthz')({
  component: HealthCheck,
});

function HealthCheck() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="rounded-lg border border-border bg-card p-8 shadow-sm">
        <h1 className="mb-4 text-2xl font-bold text-card-foreground">Health Check</h1>
        <div className="space-y-2 text-sm">
          <p className="text-green-600">
            <span className="mr-2">●</span>
            Status: <strong>OK</strong>
          </p>
          <p className="text-muted-foreground">Timestamp: {new Date().toISOString()}</p>
          <p className="text-muted-foreground">App: Molchanovs Move</p>
        </div>
      </div>
    </div>
  );
}
